import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/operator/catch';
import { combineEpics, type ActionsObservable } from 'redux-observable';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type { State } from '../model/types.tsx';
import fetchChannelsInfoEpic from './fetch-channels-info/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<any>, store: MiddlewareAPI<State>) =>
	combineEpics(fetchChannelsInfoEpic)(action$, store).catch((error, stream) => {
		log.safeErrorWithoutCustomerData('navigation-apps.channels-jsd.ops', 'Unhandled error');
		return stream;
	});
